export enum NameGeneratorPartType {
  ALPHABETIC_SERIAL_NUMBER = 'ALPHABETIC_SERIAL_NUMBER',
  NUMERIC_SERIAL_NUMBER = 'NUMERIC_SERIAL_NUMBER',
  PROPERTY_VALUE = 'PROPERTY_VALUE',
  CUSTOM_TEXT = 'CUSTOM_TEXT',
  CALCULATED_VALUE = 'CALCULATED_VALUE'
}
